
export function OAuthConfig() {
    return {
        appId: 'ed5bb792-f119-4561-8521-a5e76295169a',
        authorizationBaseUrl: `https://login.microsoftonline.com/4775a0e7-17fa-461b-9261-6ad10e34be32/oauth2/v2.0/authorize`,
        scope: 'ed5bb792-f119-4561-8521-a5e76295169a/.default offline_access', // default scope with clientid required to make openssl check to pass in api platform
        logsEnabled: true,
        web: {
            redirectUrl: import.meta.env.VITE_DOMAIN_LOGIN_URL,
            windowOptions: 'height=600,left=0,top=0',
            accessTokenEndpoint: 'https://login.microsoftonline.com/4775a0e7-17fa-461b-9261-6ad10e34be32/oauth2/v2.0/token',
            responseType: "code", // implicit flow
            pkceEnabled: true,
        },
        android: {
            responseType: "code",
            pkceEnabled: true,
            accessTokenEndpoint: 'https://login.microsoftonline.com/4775a0e7-17fa-461b-9261-6ad10e34be32/oauth2/v2.0/token',
            redirectUrl: 'msauth://aero.nayak.mro.jerkee/VzSiQcXRmi2kyjzcA+mYLEtbGVs=', // See Azure Portal -> Authentication -> Android Configuration "Redirect URI"
            handleResultOnNewIntent: true,
            handleResultOnActivityResult: true
        },
        ios: {
            responseType: "code",
            pkceEnabled: true,
            redirectUrl: 'msauth.aero.nayak.mro.jerkee://auth',
            accessTokenEndpoint: 'https://login.microsoftonline.com/4775a0e7-17fa-461b-9261-6ad10e34be32/oauth2/v2.0/token',
        },
    }

}

export function OAuthRefreshConfig(refreshToken) {
    return {
        appId: 'ed5bb792-f119-4561-8521-a5e76295169a',
        accessTokenEndpoint: 'https://login.microsoftonline.com/4775a0e7-17fa-461b-9261-6ad10e34be32/oauth2/v2.0/token',
        scope: 'ed5bb792-f119-4561-8521-a5e76295169a/.default offline_access', // default scope with clientid required to make openssl check to pass in api platform
        refreshToken: refreshToken
    }

}
